import { Dashboard } from "@platformx/dashboard";
import { lazy } from "react";

const LazySpace = lazy(() =>
  import(`@platformx/community`).then((module) => ({
    default: module?.Space,
  })),
);
const LazyUserGroupListing = lazy(() =>
  import(`@platformx/user-groups`).then((module) => ({
    default: module?.UserGroupListing,
  })),
);
const LazyUserList = lazy(() =>
  import(`@platformx/user-management`).then((module) => ({
    default: module?.UserListing,
  })),
);
const LazyUserRole = lazy(() =>
  import(`@platformx/user-role`).then((module) => ({
    default: module?.UserRole,
  })),
);
const LazyUserPermissionAssignation = lazy(() =>
  import(`@platformx/user-role`).then((module) => ({
    default: module?.PermissionAssignatation,
  })),
);

const LazyWorkflowManagement = lazy(() =>
  import(`@platformx/workflow-management`).then((module) => ({
    default: module?.WorkflowManagement,
  })),
);
const LazyNavTreeCreation = lazy(() =>
  import(`@platformx/nav-menu`).then((module) => ({
    default: module?.default,
  })),
);
const LazyHeaderSetting = lazy(() =>
  import(`@platformx/site-setting`).then((module) => ({
    default: module?.HeaderSetting,
  })),
);
const LazyFooterSetting = lazy(() =>
  import(`@platformx/site-setting`).then((module) => ({
    default: module?.FooterSetting,
  })),
);
const LazyFooterSettingNew = lazy(() =>
  import(`@platformx/site-setting`).then((module) => ({
    default: module?.FooterSettingNew,
  })),
);
const LazyHeaderSettingNew = lazy(() =>
  import(`@platformx/site-setting`).then((module) => ({
    default: module?.HeaderSettingNew,
  })),
);
const LazyCookieSetting = lazy(() =>
  import(`@platformx/site-setting`).then((module) => ({
    default: module?.CookieSetting,
  })),
);
const LazyMediaHandle = lazy(() =>
  import(`@platformx/site-setting`).then((module) => ({
    default: module?.MediaHandle,
  })),
);
const LazyGlobalSetting = lazy(() =>
  import(`@platformx/site-setting`).then((module) => ({
    default: module?.GlobalSetting,
  })),
);
const LazyThemeBuilder = lazy(() =>
  import(`@platformx/site-setting`).then((module) => ({
    default: module?.ThemeBuilder,
  })),
);
const LazyTagListing = lazy(() =>
  import(`@platformx/site-setting`).then((module) => ({
    default: module?.TagListing,
  })),
);

const LazyConfigManager = lazy(() =>
  import(`@platformx/site-setting`).then((module) => ({
    default: module?.ConfigManager,
  })),
);

const LazySiteListing = lazy(() =>
  import(`@platformx/sites`).then((module) => ({
    default: module?.SiteListing,
  })),
);
const LazyModuleSubmoduleAssignatation = lazy(() =>
  import(`@platformx/sites`).then((module) => ({
    default: module?.ModuleAssignatation,
  })),
);
const LazyAssetListing = lazy(() =>
  import(`@platformx/asset-manager`).then((module) => ({
    default: module?.AssetListing,
  })),
);
const LazyDynamicComponentContainer = lazy(() =>
  import(`@platformx/schema-based-content-type`).then((module) => ({
    default: module?.DynamicComponentContainer,
  })),
);
const LazyContent = lazy(() =>
  import(`@platformx/content`).then((module) => ({
    default: module?.Content,
  })),
);
const LazyCollection = lazy(() =>
  import(`@platformx/content`).then((module) => ({
    default: module?.Content,
  })),
);
const LazyWorkflowDetails = lazy(() =>
  import(`@platformx/workflow-management`).then((module) => ({
    default: module?.WorkflowDetails,
  })),
);
const LazyCreateUser = lazy(() =>
  import(`@platformx/user-management`).then((module) => ({
    default: module?.CreateUser,
  })),
);
const LazyCreateSpace = lazy(() =>
  import(`@platformx/community`).then((module) => ({
    default: module?.CreateSpace,
  })),
);
const LazyCommonContentRender = lazy(() =>
  import(`@platformx/content-preview`).then((module) => ({
    default: module?.CommonContentRender,
  })),
);
const LazyCreateCourse = lazy(() =>
  import(`@platformx/course`).then((module) => ({
    default: module?.CreateCourse,
  })),
);
const LazyCreateAsset = lazy(() =>
  import(`@platformx/asset-manager`).then((module) => ({
    default: module?.CreateAsset,
  })),
);
const LazyFeatureFlagSetting = lazy(() =>
  import(`@platformx/site-setting`).then((module) => ({
    default: module?.FeatureFlagSetting,
  })),
);
const LazyCategoryDetail = lazy(() =>
  import(`@platformx/site-setting`).then((module) => ({
    default: module?.CategoryDetail,
  })),
);
const LazyCreateTags = lazy(() =>
  import(`@platformx/site-setting`).then((module) => ({
    default: module?.CreateTags,
  })),
);
const LazyAddSite = lazy(() =>
  import(`@platformx/sites`).then((module) => ({
    // default: module?.AddSite,
    default: module?.SiteCreationDialog,
  })),
);
const LazyCreateArticle = lazy(() =>
  import(`@platformx/content`).then((module) => ({
    default: module?.CreateArticle,
  })),
);
const LazyPrelemsList = lazy(() =>
  import(`@platformx/content`).then((module) => ({
    default: module?.PrelemsList,
  })),
);
const LazyCreatePoll = lazy(() =>
  import(`@platformx/content`).then((module) => ({
    default: module?.CreatePoll,
  })),
);
const LazyCreateVOD = lazy(() =>
  import(`@platformx/content`).then((module) => ({
    default: module?.CreateVod,
  })),
);
const LazyCreateQuiz = lazy(() =>
  import(`@platformx/content`).then((module) => ({
    default: module?.CreateQuiz,
  })),
);
const LazyCreateEvent = lazy(() =>
  import(`@platformx/content`).then((module) => ({
    default: module?.CreateEvent,
  })),
);
const LazyCreateUserGroup = lazy(() =>
  import(`@platformx/user-groups`).then((module) => ({
    default: module?.CreateUserGroup,
  })),
);
const LazyTimeLineBlogs = lazy(() =>
  import(`@platformx/content`).then((module) => ({
    default: module?.TimeLineBlogs,
  })),
);
const LazySearchPrelem = lazy(() =>
  import(`@platformx/site-page`).then((module) => ({
    default: module?.SearchPrelem,
  })),
);
const LazyPrelemInfo = lazy(() =>
  import(`@platformx/site-page`).then((module) => ({
    default: module?.PrelemInfo,
  })),
);
const LazyEditPage = lazy(() =>
  import(`@platformx/site-page`).then((module) => ({
    default: module?.EditPage,
  })),
);
const LazyAccessDenied = lazy(() =>
  import(`@platformx/utilities`).then((module) => ({
    default: module?.AccessDenied,
  })),
);
const LazyCharts = lazy(() =>
  import(`@platformx/charts`).then((module) => ({
    default: module?.Charts,
  })),
);
const LazyCommonPreview = lazy(() =>
  import(`@platformx/content-preview`).then((module) => ({
    default: module?.CommonPreview,
  })),
);
const LazyEcommerce = lazy(() =>
  import(`@platformx/report`).then((module) => ({
    default: module?.Ecommerce,
  })),
);
const LazyLoyalty = lazy(() =>
  import(`@platformx/report`).then((module) => ({
    default: module?.Loyalty,
  })),
);
const LazyFormBuilder = lazy(() =>
  import(`@platformx/form-builder`).then((module) => ({
    default: module?.FormBuilderAuthoringContainer,
  })),
);
//This component is for run prelem component on local
const LazyPrelemComponent = lazy(() =>
  import("../../components/PrelemLibrary/PrelemComponent").then((module) => ({
    default: module?.default,
  })),
);

const LazyFormView = lazy(() =>
  import(`@platformx/form-builder`).then((module) => ({
    default: module?.FormView,
  })),
);

const LazyTimeLineTournamentBlogs = lazy(() =>
  import(`@platformx/tournament-blog`).then((module) => ({
    default: module?.TimeLineTournamentBlogs,
  })),
);

const Components = {
  dashboard: Dashboard,
  space: LazySpace,
  userGroupListing: LazyUserGroupListing,
  userListing: LazyUserList,
  userRole: LazyUserRole,
  userPermissionAssignation: LazyUserPermissionAssignation,
  moduleSubmoduleAssignatation: LazyModuleSubmoduleAssignatation,
  workflowManagement: LazyWorkflowManagement,
  navTreeCreation: LazyNavTreeCreation,
  headerSetting: LazyHeaderSetting,
  footerSetting: LazyFooterSetting,
  cookieSetting: LazyCookieSetting,
  mediaHandle: LazyMediaHandle,
  globalSetting: LazyGlobalSetting,
  themeBuilder: LazyThemeBuilder,
  tagListing: LazyTagListing,
  configManager: LazyConfigManager,
  siteListing: LazySiteListing,
  assetListing: LazyAssetListing,
  dynamicComponentContainer: LazyDynamicComponentContainer,
  content: LazyContent,
  collection: LazyCollection,
  workflowDetails: LazyWorkflowDetails,
  createUser: LazyCreateUser,
  createSpace: LazyCreateSpace,
  commonContentRender: LazyCommonContentRender,
  createCourse: LazyCreateCourse,
  createAsset: LazyCreateAsset,
  featureFlagSetting: LazyFeatureFlagSetting,
  categoryDetail: LazyCategoryDetail,
  createTags: LazyCreateTags,
  addSite: LazyAddSite,
  createArticle: LazyCreateArticle,
  createUserGroup: LazyCreateUserGroup,
  timeLineBlogs: LazyTimeLineBlogs,
  searchPrelem: LazySearchPrelem,
  prelemInfo: LazyPrelemInfo,
  editPage: LazyEditPage,
  accessDenied: LazyAccessDenied,
  userEngagement: LazyCharts,
  sitePerformance: LazyCharts,
  prelemPreview: LazyCommonPreview,
  pagePreview: LazyCommonPreview,
  contentPreview: LazyCommonPreview,
  ecommerce: LazyEcommerce,
  loyalty: LazyLoyalty,
  formBuilder: LazyFormBuilder,
  prelemComponent: LazyPrelemComponent,
  formView: LazyFormView,
  createPoll: LazyCreatePoll,
  createVOD: LazyCreateVOD,
  createEvent: LazyCreateEvent,
  createQuiz: LazyCreateQuiz,
  createFooterNew: LazyFooterSettingNew,
  createHeaderNew: LazyHeaderSettingNew,
  prelemsList: LazyPrelemsList,
  timeLineTournamentBlogs: LazyTimeLineTournamentBlogs,
};

export default Components;
